'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILTER_TYPE = exports.FILTER_TYPE = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  MULTISELECT: 'MULTISELECT',
  NUMBER: 'NUMBER',
  DATE: 'DATE'
};

var FILTER_DELAY = exports.FILTER_DELAY = 500;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-table2-filter/lib/src/const.js
// module id = 80
// module chunks = 0